import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { usePermissions } from '../../../hooks/usePermissions';
import { UPDATE_SUPPLIER } from '../../../constants/eInvoicePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';

const SupplierActionsMenu = ({ supplier }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const { suppliers: s } = useTranslatedMessages();
  const { hasEInvoicePermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();
  const canUpdate = hasEInvoicePermission(UPDATE_SUPPLIER);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const onClickingDetails = () => {
    handleClose();
    navigate('/suppliers/:id'.replace(':id', supplier.profile_id));
  };
  const onClickingEdit = () => {
    if (!canUpdate) {
      return;
    }
    handleClose();
    navigate('/suppliers/:id/edit'.replace(':id', supplier.profile_id));
  };

  return (
    <>
      <IconButton id="action-icon-button" onClick={handleClick} aria-label={s?.actions_menu?.aria_more || 'more'}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              boxShadow: '4px 4px 10px 0px rgba(0, 0, 0, 0.2)',
            },
          },
        }}
      >
        <MenuItem data-testid="details" key="details" onClick={onClickingDetails}>
          {s?.actions_menu?.details || 'Details'}
        </MenuItem>
        <PermissionDeniedWrapper show={!canUpdate} title={accessDeniedMessage} fullWidth>
          <MenuItem data-testid="edit" disabled={!canUpdate} onClick={onClickingEdit}>
            {s?.actions_menu?.edit || 'Edit'}
          </MenuItem>
        </PermissionDeniedWrapper>
      </Menu>
    </>
  );
};

export default SupplierActionsMenu;
